export default "__VITE_ASSET__DK9n$pcF__"